import Vue from 'vue'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import ToastificationMessage from '@/@core/components/toastification/ToastificationMessage.vue'
import router from '@/router'
import { parseErrorObject } from './utils'

function isV2Route() {
  return router?.currentRoute?.path?.startsWith('/v2')
}

function resolveTitle(title) {
  return typeof title === 'object' ? parseErrorObject(title) : title
}

function showV2Toast(title, variant, {
  position = 'bottom-center',
  toastClassName = 'v2-toast',
  timeout,
  closeOnClick,
} = {}) {
  const options = { position, toastClassName }
  if (timeout !== undefined) options.timeout = timeout
  if (closeOnClick !== undefined) options.closeOnClick = closeOnClick
  Vue.prototype.$toast({
    component: ToastificationMessage,
    props: {
      title,
      variant,
    },
  }, options)
}

function showLegacyToast({
 title, icon, text, variant, defaultIcon, v2Variant,
}) {
  const resolvedTitle = resolveTitle(title)
  if (isV2Route()) {
    const combinedTitle = text ? `${resolvedTitle} — ${text}` : resolvedTitle
    showV2Toast(combinedTitle, v2Variant, { timeout: 5000, closeOnClick: true })
    return
  }
  Vue.prototype.$toast({
    component: ToastificationContent,
    props: {
      title: resolvedTitle,
      text,
      icon: icon || defaultIcon,
      variant,
    },
  })
}

export function apiToastSuccess(title, icon, text) {
  showLegacyToast({
 title, icon, text, variant: 'success', defaultIcon: 'CheckCircleIcon', v2Variant: 'success',
})
}

export function apiToastWarning(title, icon, text) {
  showLegacyToast({
 title, icon, text, variant: 'warning', defaultIcon: 'AlertCircleIcon', v2Variant: 'warning',
})
}

export function apiToastError(title, icon, text) {
  showLegacyToast({
 title, icon, text, variant: 'danger', defaultIcon: 'AlertTriangleIcon', v2Variant: 'danger',
})
}

// A rejected request has ALREADY been toasted by the axios interceptor, and
// apiToastError renders its first argument as the title — so passing the error
// object straight in produces an empty toast on top of the interceptor's one.
// This speaks up only for failures the interceptor stayed silent about (no
// response: offline, aborted, a client-side throw), and always with a sentence.
export function apiToastFailure(err, message) {
  if (err && err.response) return
  apiToastError(message)
}

export function apiToastSuccessV2(title) {
  showV2Toast(resolveTitle(title), 'success', { position: 'top-center', toastClassName: 'custom-toast' })
}

export function apiToastErrorV2(title) {
  showV2Toast(resolveTitle(title), 'danger', { position: 'top-center', toastClassName: 'custom-toast' })
}
